import { fetchVidboardAssets } from "../../api/assets";
import { setShapes, setData } from "../../store/assets/assetsSlice";
import { setIdle, setLoading } from "../../store/common/appStateSlice";

export const getAssestsData = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const data = await fetchVidboardAssets();
    dispatch(setShapes(data?.shapes));
    dispatch(setData(data));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading vidboard assets:", error);
    // Handle the error state appropriately, e.g., setting an error state in your store
    dispatch(setIdle());
  }
};
export const getArrowData = () => async (dispatch, getState) => {
  const shapes = getState().assets.data || {};
  if (shapes.arrows) {
    return dispatch(setShapes(shapes?.arrows));
  }
};

export const getIconsData = () => async (dispatch, getState) => {
  const shapes = getState().assets.data || {};
  if (shapes.icons) {
    return dispatch(setShapes(shapes?.icons));
  }
};
export const getLinesData = () => async (dispatch, getState) => {
  const shapes = getState().assets.data || {};
  if (shapes.icons) {
    return dispatch(setShapes(shapes?.lines));
  }
};

export const infographics = () => async (dispatch, getState) => {
  const shapes = getState().assets.data || {};
  if (shapes.infographics) {
    return dispatch(setShapes(shapes?.infographics));
  }
};
